<div class="add-mcp-servers" [formGroup]="addMcpServersFormGroup">
  <app-popup-top-line></app-popup-top-line>
  <div class="add-mcp-servers-header">
    <div class="title">
      {{ 'policyPage.config.mcpServerFilteringContent.addMcpServerDialogTitle' | labelsProvider }}
    </div>
    <img class="close-button" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="add-mcp-servers-body" formArrayName="mcpServersToAdd">
    <div class="add-mcp-servers-body-description">
      {{ 'policyPage.config.mcpServerFilteringContent.addMcpServerDialogDescription' | labelsProvider }}
    </div>

    @for (control of mcpServersToAdd.controls; track $index) {
      <div [formGroupName]="$index">
        <div
          class="input"
          [ngClass]="{
            'input-invalid': control.get('url')?.touched && control.get('url')?.invalid,
            'input-valid': control.get('url')?.touched && control.get('url')?.valid,
          }"
        >
          <input
            type="text"
            formControlName="url"
            placeholder="{{ 'policyPage.config.mcpServerFilteringContent.enterMcpServerUrl' | labelsProvider }}"
          />
          @if ($index > 0) {
            <img src="assets/images/common/cancel.svg" (click)="removeMcpServer($index)" />
          }
        </div>
        @if (control.get('url')?.touched && control.get('url')?.invalid && control.get('url')?.value) {
          <div class="error-message">
            {{ 'policyPage.config.mcpServerFilteringContent.invalidMcpServerUrl' | labelsProvider }}
          </div>
        }
      </div>
    }

    @if (mcpServersToAdd.controls.length < maxMcpServersToAdd) {
      <div class="add-more" (click)="addMoreClicked()">
        <img class="add-more-img" src="assets/images/common/plus.svg" />
        <span>{{ 'policyPage.config.mcpServerFilteringContent.addMoreButton' | labelsProvider }}</span>
      </div>
    }
  </div>

  <div class="add-mcp-servers-footer">
    <button class="cancel-button" (click)="onClose()">
      <span>{{ 'policyPage.config.mcpServerFilteringContent.cancelButton' | labelsProvider }}</span>
    </button>
    <button class="submit-button" (click)="onSubmit()" [disabled]="addMcpServersFormGroup.invalid">
      <span>{{ 'policyPage.config.mcpServerFilteringContent.addButton' | labelsProvider }}</span>
    </button>
  </div>
</div>
